import { ChangeDetectionStrategy, Component } from '@angular/core'
import { AuthService } from '@core/auth.service'

@Component({
   selector: 'app-access-denied',
   templateUrl: './access-denied.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {
   constructor(public authService: AuthService) {}
}

